module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1526-79f8148f07fa89edd5795484e28172ec.png";